import { render, staticRenderFns } from "./Process-2.vue?vue&type=template&id=33850417&scoped=true&"
import script from "./Process-2.vue?vue&type=script&lang=js&"
export * from "./Process-2.vue?vue&type=script&lang=js&"
import style0 from "./Process-2.vue?vue&type=style&index=0&id=33850417&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33850417",
  null
  
)

export default component.exports